import gql from "graphql-tag";

export const GET_NOTICES = gql`
  query notices {
    notices {
      id
      title
      description
      created_at
      notice_date
      notice_file {
        mime
        url
      }
    }
  }
`;

export const GET_NOTICE_BY_ID = gql`
  query notice($id: ID!) {
    notice(id: $id) {
      id
      title
      description
      notice_date
      notice_file {
        name
        mime
        url
      }
      created_at
    }
  }
`;

export const GET_NOTICES_LIMIT = gql`
  query notices($limit: Int, $start: Int, $sort: String) {
    notices(limit: $limit, start: $start, sort: $sort) {
      id
      title
      description
      notice_file {
        name
        mime
        url
      }
      created_at
      notice_date
    }
  }
`;

export const GET_NOTICES_BY_CONDITION = gql`
  query notices($where: JSON) {
    notices(where: $where) {
      id
      title
      description
      notice_file {
        name
        mime
        url
      }
      created_at
      notice_date
    }
  }
`;

export const GET_NOTICES_COUNT = gql`
  query noticesCount {
    noticesCount
  }
`;

export const GET_NOTICE_NAVIGATION_BY_PROGRAM_ID = gql`
  query notices($where: JSON, $sort: String, $limit: Int) {
    notices(where: $where, sort: $sort, limit: $limit) {
      id
      title
      description
      notice_file {
        name
        mime
        url
      }
      created_at
      notice_date
    }
  }
`;

// query{
//   notices(where:{id_gt:40},limit:1,sort:"id:ASC"){
//     id
//   }
// }

// query{
//   notices(where:{id_lt:40},limit:1,sort:"id:DESC"){
//     id
//   }
// }
